module.exports = __webpack_public_path__ + "img/red.f49c8a40.svg";